export function capitalizeFirstLetter(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}


export const getValuesFromForm = (values: any) => {
    let tmp = values;
    tmp = JSON.stringify(tmp);
	tmp = JSON.parse(tmp)

    return tmp;
}

export const getQueryParam = (key: string) => {
    let hash = window.location.hash;
    let paramString = hash.split("?");
    
    if (paramString.length > 0) {
        let queryParams = paramString[1];

        const params = new URLSearchParams(queryParams); 
        const queryParam = params.get(key);
        
        return queryParam;
    }
    return undefined;
}

export const addQueryParam = (url: string, key: string, value: string): string => {
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.set(key, value);
        return urlObj.toString();
    } catch (e) {
        // Handle error if URL is invalid or other issues arise
        return url; // Return the original URL if an error occurs
    }
}

export const addQueryParams = (url: string, params: Record<string, string>): string => {
    try {
        const urlObj = new URL(url);
        Object.entries(params).forEach(([key, value]) => {
            urlObj.searchParams.set(key, value);
        });
        return urlObj.toString();
    } catch (e) {
        // Handle error if URL is invalid or other issues arise
        return url; // Return the original URL if an error occurs
    }
}